export const CONSTANTS = {
  DROPDOWN_SEARCH_THRESHOLD: 10,
  DROPDOWN_MAX_ITEMS_TO_DISPLAY: 50,
  DROPDOWN_SCROLL_THRESHOLD: 3,
  DROPDOWN_GROUPS_AND_ADMINS_SCROLL_THRESHOLD: 3,
  AVATAR_GROUP_MAX_ITEMS_TO_DISPLAY: 4,
  DROPDOWN_ITEM_HEIGHT: 48, // 42px item height + 4px gap between items
};
